import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumManagerService, EnumData } from './enum-manager.service';

export interface EnumOperations {
  loadEnums(): Observable<EnumData>;
  getEnumState(): Observable<any>;
  validateEnums(): boolean;
  refreshEnums(): Observable<EnumData>;
  clearCache(): void;
  getMediaTypes(): string[];
  getUsageMediums(): string[];
  getRegions(): string[];
}

@Injectable({
  providedIn: 'root',
})
export class EnumOperationsService implements EnumOperations {
  constructor(private enumManager: EnumManagerService) {}

  /**
   * Load enums from the server
   */
  loadEnums(): Observable<EnumData> {
    return this.enumManager.loadEnums();
  }

  /**
   * Get the current enum state as an observable
   */
  getEnumState(): Observable<any> {
    return this.enumManager.getEnumState();
  }

  /**
   * Validate if all required enums are loaded
   */
  validateEnums(): boolean {
    return this.enumManager.validateEnums();
  }

  /**
   * Force refresh enums (ignores cache)
   */
  refreshEnums(): Observable<EnumData> {
    return this.enumManager.refreshEnums();
  }

  /**
   * Clear the enum cache
   */
  clearCache(): void {
    this.enumManager.clearCache();
  }

  /**
   * Get specific enum values
   */
  getMediaTypes(): string[] {
    return this.enumManager.getMediaTypes();
  }

  getUsageMediums(): string[] {
    return this.enumManager.getUsageMediums();
  }

  getRegions(): string[] {
    return this.enumManager.getRegions();
  }

  /**
   * Check if enums are currently loading
   */
  isLoading(): boolean {
    return this.enumManager.isLoading();
  }

  /**
   * Check if enums are loaded
   */
  isLoaded(): boolean {
    return this.enumManager.isLoaded();
  }

  /**
   * Check if there's an error
   */
  hasError(): boolean {
    return this.enumManager.hasError();
  }

  /**
   * Get the current error message
   */
  getError(): string | null {
    return this.enumManager.getError();
  }
} 